import {
    BaseEntity,
    EquipmentResponse,
    TvGroup,
} from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate/dto/ResponseDto';

import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

type TIncomingEntities = {
    tv: Record<string, TvGroup>,
    onlineCinemas: BaseEntity,
    entertainments: BaseEntity,
    antivirus: BaseEntity,
    security: BaseEntity,
    routers: Record<number, EquipmentResponse>,
    decoders: Record<number, EquipmentResponse>,
}

const prepareDescription = (incoming: TIncomingEntities) => {
    return {
        [EEntity.onlineCinemas]: {
            header: incoming[EEntity.onlineCinemas]?.header,
            description: incoming[EEntity.onlineCinemas]?.description,
        },
        [EEntity.additional]: {
            header: incoming[EEntity.entertainments]?.header,
            description: incoming[EEntity.entertainments]?.description,
        },
        [EEntity.antivirus]: {
            header: incoming[EEntity.antivirus]?.header,
            description: incoming[EEntity.antivirus]?.description,
        },
        [EEntity.security]: {
            header: incoming[EEntity.security]?.header,
            description: incoming[EEntity.security]?.description,
        },
    };
};

export default prepareDescription;
